// src/utils/appcheck.js
import { getToken } from "firebase/app-check";
import { appCheck } from "../firebase";

export async function appCheckHeader() {
    try {
        if (!appCheck) return {}; // 👈 evita errore se è null (locale/staging)

        const { getToken } = await import("firebase/app-check");
        const t = await getToken(appCheck, /* forceRefresh */ false);
        return { "X-Firebase-AppCheck": t.token };
    } catch (err) {
        console.warn("AppCheck non disponibile:", err?.message);
        return {}; // fallback sicuro
    }
}